import { useId, useState, type FormEvent } from 'react';
import { LiksButton } from '../LiksButton/LiksButton';
import { LiksDialog } from '../LiksDialog/LiksDialog';
import './ChatSessionRenameDialog.css';

type ChatSessionRenameDialogProps = {
  isOpen: boolean;
  title: string;
  initialValue: string;
  inputLabel: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: (value: string) => void;
  onCancel: () => void;
};

export function ChatSessionRenameDialog({
  isOpen,
  ...rest
}: ChatSessionRenameDialogProps) {
  if (!isOpen) {
    return null;
  }

  return <ChatSessionRenameDialogContent {...rest} />;
}

type ChatSessionRenameDialogContentProps = Omit<
  ChatSessionRenameDialogProps,
  'isOpen'
>;

function ChatSessionRenameDialogContent({
  title,
  initialValue,
  inputLabel,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
}: ChatSessionRenameDialogContentProps) {
  const inputId = useId();
  const [value, setValue] = useState(initialValue);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onConfirm(value);
  };

  return (
    <LiksDialog
      isOpen
      as="form"
      size="sm"
      title={title}
      onClose={onCancel}
      onSubmit={handleSubmit}
      footer={
        <>
          <LiksButton variant="secondary" type="button" onClick={onCancel}>
            {cancelLabel}
          </LiksButton>
          <LiksButton
            variant="primary"
            type="submit"
            disabled={value.trim() === ''}
          >
            {confirmLabel}
          </LiksButton>
        </>
      }
    >
      <label className="liks-chat-session-rename__label" htmlFor={inputId}>
        {inputLabel}
      </label>
      <input
        id={inputId}
        className="liks-chat-session-rename__input"
        type="text"
        value={value}
        onChange={(event) => setValue(event.target.value)}
        autoFocus
      />
    </LiksDialog>
  );
}
